/**
 * AssetsKpiRow — the "Assets Information" KPI band.
 *   TOTAL ASSETS | NEW ASSETS (origin=ivt_incubated) | 本月新增 (createdAt, plain text) | [TITLE]
 * TITLE is 🧩 a placeholder (PM hasn't defined it) — the card slot exists but the
 * 4th card is NOT rendered this milestone (feature flag `showTitle`, default false).
 * "本月新增" shows "+N" in plain text — NO green (green only marks isNew assets).
 */
import type { AssetKpis } from '../utils/assetGrouping';

interface Props {
  kpis: AssetKpis;
  /** 🧩 TITLE KPI card — off until PM defines it. */
  showTitle?: boolean;
}

export default function AssetsKpiRow({ kpis, showTitle = false }: Props) {
  return (
    <section className="ivt-assets-kpi" aria-label="Assets Information">
      <h2 className="ivt-assets-kpi__title">Assets Information</h2>
      <div className="ivt-assets-kpi__cells">
        <div className="ivt-assets-kpi__cell">
          <span className="ivt-assets-kpi__label">TOTAL ASSETS</span>
          <span className="ivt-assets-kpi__value">{kpis.total}</span>
        </div>
        <div className="ivt-assets-kpi__cell">
          <span className="ivt-assets-kpi__label">NEW ASSETS</span>
          <span className="ivt-assets-kpi__value">{kpis.newCount}</span>
        </div>
        <div className="ivt-assets-kpi__cell">
          <span className="ivt-assets-kpi__label">本月新增</span>
          <span className="ivt-assets-kpi__value ivt-assets-kpi__value--delta">
            +{kpis.createdThisMonth}
          </span>
        </div>
        {showTitle && (
          <div className="ivt-assets-kpi__cell">
            <span className="ivt-assets-kpi__label">TITLE</span>
            <span className="ivt-assets-kpi__value">—</span>
          </div>
        )}
      </div>
    </section>
  );
}
